import React from 'react';
import WarehouseOpsPage from './WarehouseOpsPage';
export default function InventoryRegister() {
  return <WarehouseOpsPage mode="stock" title="Inventory Register" subtitle="Track packages and their current locations" />;
}
